import * as React from 'react';
import { DataGrid, GridToolbar, GridToolbarExport, GridToolbarContainer } from '@mui/x-data-grid';
import { useEffect, useState } from "react";
import { Autocomplete, Button, Container, Grid, Icon, TextField, Tab, Box, CardHeader } from "@mui/material";
import { Alert } from 'app/components/Alert';
import { InventoryService } from 'app/services/inventoryService';
import { ClientService } from 'app/services/client-service';
import Loading from 'app/components/MatxLoading';
import { ValidatorForm } from "react-material-ui-form-validator";
import { SkuService } from 'app/services/SkuService';
import moment from 'moment';
import useAuth from 'app/hooks/useAuth';
import LoadingModelComponent from 'app/components/LoadingModelComponent';
function getDate(params) {

    return `${params.row.inventoryDate.zoneCode} `;
}
function GetStockInHandQty(params) {
    return `${params.row.avail_qty - params.row.allocation_qty} `;
}
const columns = [
    { field: 'Id', headerName: 'Id', width: 110, hide: true },
    { field: 'client_name', headerName: 'Client Name', width: 180 },
    { field: 'client_SKU_ID', headerName: 'Client_SKU_ID', width: 150 },
    { field: 'ajex_barcode', headerName: 'Ajex_Barcode', width: 150 },
    { field: 'description', headerName: 'Description', width: 210 },
    { field: 'category', headerName: 'Category', width: 180, },
    { field: 'temperature', headerName: 'Temperature', width: 150 },
    { field: 'warehouse_name', headerName: 'Warehouse_Name', width: 150 },
    { field: 'location_code', headerName: 'Location Code', width: 140 },
    { field: 'avail_qty', headerName: 'Avail_qty', width: 80 },
    { field: 'allocation_qty', headerName: 'Allocation_Qty', width: 120 },
    { field: 'StockInHandQty', headerName: 'In-Hand_qty', width: 120, valueGetter: GetStockInHandQty },
    { field: 'batch_Id', headerName: 'Batch_Id', width: 100 },
    { field: 'manufacturing_date', headerName: 'manufacturing_date', width: 180, valueFormatter: params => { if (params?.value) return moment(params?.value).format("DD/MMM/yyyy hh:mm") } },
    { field: 'expire_date', headerName: 'expire_date', width: 180, valueFormatter: params => { if (params?.value) return moment(params?.value).format("DD/MMM/yyyy hh:mm") } },
    { field: 'expire_Status', headerName: 'expire_Status', width: 180 },
    { field: 'container_no', headerName: 'container_no', width: 180 },
    { field: 'length', headerName: 'length', width: 180 },
    { field: 'width', headerName: 'width', width: 180 },
    { field: 'height', headerName: 'height', width: 180 },
    { field: 'volumetric_CBM', headerName: 'volumetric_CBM', width: 180 },
    { field: 'total_CBM', headerName: 'total_CBM', width: 180 },
    { field: 'checkIN_Date', headerName: 'checkIN_Date', width: 180, valueFormatter: params => { if (params?.value) return moment(params?.value).format("DD/MMM/yyyy hh:mm") } },



];



export default function StockReport() {

    const [clientNames, setClientNames] = useState([]);
    const [clientId, setClientId] = useState('');
    const [isLoaded, setIsLoaded] = useState(false);
    const [ClientSKUList, setClientSKUList] = useState([]);
    const [stockReport, setstockReport] = useState([]);
    const [SKUId, setSKUId] = useState('');
    const [page, setPage] = useState(25);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const { user } = useAuth();
    // const [inputValue, setInputValue] = useState('')
    // const [filtid, setFiltid] = useState([])
    // const [filteredId, setfilteredId] = useState({})
    // const [value, setValue] = useState("")
    const [clientName, setClientName] = useState('')
    const [searchquery, setSearchQuery] = useState([])
    const [newarr, setNewarr] = useState([])

    useEffect(() => {

        //setClientId(user?.clientId);
        setIsLoaded(true)
        InventoryService.ClientStockReport(user?.clientId).then(skureport => {
            if (skureport || skureport.length !== 0) {
                setstockReport(skureport)
                setSearchQuery(skureport)
                var myArray = [];
                const unique = [...new Set(skureport.map((item) => item.container_no))];
                console.log(unique);

                unique.forEach((element) => {
                    var updatedlevel = { id: 0, container_no: "" };
                    updatedlevel.id = element;
                    updatedlevel.container_no = element;
                    myArray.push(updatedlevel);
                });
                setNewarr(myArray);
                setIsLoaded(false)
            }
        })
            .catch((err) => { console.log(err.message) });
    }, [user]);
    // useEffect(() => {
    //     setIsLoaded(true);
    //     ClientService
    //         .getAllClientNames()
    //         .then(client => { setClientNames(client); setIsLoaded(false); })
    //         .catch((err) => { console.log(err.message); setIsLoaded(false); });
    // }, []
    // );

    const clientChange = (event, value) => {

        if (value) {
            setClientId(value.id);
            // getClientSku(value.id);
            setClientName(value.clientName)
        }
    }
    const SKUChange = (event, value) => {

        if (value)
            setSKUId(value.skuId);
    }
    const ShowStockReport = () => {
        setIsLoaded(true)
        InventoryService.ClientStockReport(clientId).then(skureport => {
            if (skureport || skureport.length !== 0) {
                setstockReport(skureport)
                setSearchQuery(skureport)
                var myArray = [];
                const unique = [...new Set(skureport.map((item) => item.container_no))];
                console.log(unique);

                unique.forEach((element) => {
                    var updatedlevel = { id: 0, container_no: "" };
                    updatedlevel.id = element;
                    updatedlevel.container_no = element;
                    myArray.push(updatedlevel);
                });
                setNewarr(myArray);
                setIsLoaded(false)
            }
        })
            .catch((err) => { console.log(err.message) });

    }
    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };
    // const getClientSku = (id) => {
    //     
    //     // setIsLoaded(true);
    //     SkuService
    //         .GetClientSKUList(id)
    //         .then(sku => {  setClientSKUList(sku); })
    //         .catch((err) => { console.log(err.message); });
    // }


    const levelChange = (event, value) => {
        if (event) {
            //setuserid(value.id);
            setSearchQuery(
                stockReport.filter((s) => s.container_no === event.container_no)
            );
        } else {
            setSearchQuery(stockReport);
        }
    };

    const ExcelDownload = () => {
        return (
            <GridToolbarContainer>
                <GridToolbarExport csvOptions={{
                    fileName: 'StockReport_' + clientName + '_'

                }} />
            </GridToolbarContainer>
        )
    }

    return (
        <div>
            {/* {isLoaded ? <Loading /> : null} */}
            <LoadingModelComponent isLoading={isLoaded} />
            {/* <Container> */}
            <Alert />


            <Grid margin={4} >
                {/* <CardHeader title="Client Stock Report"  >
                </CardHeader> */}
                <h4>Client Stock Report</h4>
                <Grid container spacing={1} sx={{ mt: 2 }} style={{ marginBottom: "24px" }}>
                    {/* <Grid item lg={3} md={3} sm={6} xs={6} sx={{ mt: 2 }}>
                        <Autocomplete
                            size="small"
                            value={clientNames?.find(item => (item.id === clientId)) || {}}
                            options={clientNames || {}}
                            onChange={clientChange}
                            disabled={true}
                            getOptionLabel={(option) => option.clientName || ''}
                            renderInput={(params) => (
                                <TextField {...params} label="Client Name" variant="outlined" fullWidth />
                            )}
                        />
                    </Grid> */}
                    {/* <Grid item lg={3} md={3} sm={6} xs={6} sx={{ mt: 2 }}>
                        <Autocomplete
                            size="small"
                            options={ClientSKUList}

                            onChange={SKUChange}
                            getOptionLabel={(option) => option.skuCode || ''}
                            renderInput={(params) => (
                                <TextField {...params} label="Client SKU" variant="outlined" fullWidth />
                            )}
                        />
                    </Grid> */}
                    {/* <Grid item lg={3} md={3} sm={6} xs={6} sx={{ mt: 2 }}>
                        <Button
                            size="small"
                            component="label"
                            disabled={clientId.length === 0}
                            onClick={ShowStockReport}
                            style={{ display: 'flex', height: '100%' }}
                            variant="outlined"> Show<Icon>upload</Icon>
                        </Button>
                    </Grid> */}
                    <Grid item lg={3} md={3} sm={6} xs={6} sx={{ mt: 2 }}>
                        {stockReport.length > 0 ?
                            <Autocomplete
                                size="small"
                                options={newarr}
                                getOptionLabel={(option) => option.container_no || ""}
                                onChange={(event, newValue) => {
                                    levelChange(newValue)
                                }}
                                id="combo-box-demo"
                                renderInput={(params) => (
                                    <TextField {...params} label="Filter By ID" variant="outlined" fullWidth />
                                )}
                            />
                            : null}
                    </Grid>

                </Grid>




                <Grid item lg={12} md={6} sm={12} xs={12}>

                    <div style={{ height: '450px', width: '100%' }}>
                        <DataGrid
                            density="compact"
                            rows={searchquery}
                            columns={columns}
                            pageSize={page}
                            rowsPerPage={rowsPerPage}
                            onPageSizeChange={(newPageSize) => setPage(newPageSize)}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                            rowsPerPageOptions={[5, 10, 25, 50, 75, 100]}
                            pagination
                            checkboxSelection

                            components={{ Toolbar: ExcelDownload }}
                        />

                    </div>
                </Grid>
            </Grid>
            {/* </Container> */}



        </div>
    );
}
